export class User{
  public first_name: string;
  public last_name: string;
  public role: string[];
  public employeeId: string

  constructor(fname, lname,employeeId = null, role = null){
    this.first_name = fname;
    this.last_name = lname;
    this.role = role;
    this.employeeId = employeeId;
  }
}
